/*
 * @Author: Mr.mjc
 * @Date: 2022-06-27 19:02:37
 * @LastEditors: Mr.mjc
 * @LastEditTime: 2023-02-07 09:56:31
 * @Description:
 * @FilePath: /next-ui/packages/wui-table/src/FilterType.tsx
 */
// import PropTypes from 'prop-types';
import React, {Component} from 'react';
import omit from "omit.js"
import DatePicker from '../../wui-datepicker/src';
import TimePicker from '../../wui-timepicker/src';
// import zhCN from '../../wui-datepicker/src/locale/zh_CN';
import InputNumber from '../../wui-input-number/src';
import Input from '../../wui-input/src';
import Select from '../../wui-select/src';
import Switch from '../../wui-switch/src/index'
import FilterDropDown from './FilterDropDown';
import { IFilterTypeProps, IFilterTypeState } from './iTable';
import { InputNumberDefaultProps } from '../../wui-input-number/src/iInputNumber';
import { InputProps } from '../../wui-input/src/iInput';
import { SelectProps } from '../../wui-select/src/iSelect';
import { DatePickerProps, RangePickerProps } from '../../wui-datepicker/src/iPicker';
import { TimePickerProps } from '../../wui-timepicker/src/iTimePicker';
import { SwitchProps } from '../../wui-switch/src/iSwitch';

// @ts-ignore
const {RangePicker, YearPicker, MonthPicker, WeekPicker} = DatePicker;

// const propTypes = {
//     filterDropdown: PropTypes.string,
//     filterDropdownType: PropTypes.string,
//     onFilterClear: PropTypes.func,
//     onFilterChange: PropTypes.func,
//     onChange: PropTypes.func,
//     onSelectDropdown: PropTypes.func,
//     filterInputNumberOptions: PropTypes.any,
//     filterDropdownIncludeKeys: PropTypes.string,
//     locale: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
//     rendertype: PropTypes.string,
//     // Switch: PropTypes.bool, //哪里的用处？
//     dataIndex: PropTypes.number,
//     format: PropTypes.any,
// };

class FilterType extends Component<IFilterTypeProps, IFilterTypeState> {
	static defaultProps: { filterDropdown: 'show'; };
	constructor(props:IFilterTypeProps) {
	    super(props);
	    this.state = {
	        value: "",
	        text: "",
	        selectValue: "",
	        dateValue: "",
	        open: false,
	        condition: props.filterDropdownType == 'string' ? 'LIKE' : 'EQ',
	        number: 0,
	        timeOpen: false
	    }
	}

	/**
	 * 清除过滤条件
	 *
	 */
	clearFilter = () => {
	    let {onFilterClear, dataIndex} = this.props;
	    if (this.state.value !== "") {
	        this.setState({
	            value: "", // 清空值
	            condition: this.props.filterDropdownType == 'string' ? 'LIKE' : 'EQ'// 切回默认查询条件
	        }, () => {
	            // 调用清除方法参数为当前字段的field
	            onFilterClear && dataIndex && onFilterClear(dataIndex);
	        });
	    }
	}

	/**
	 * 设置输入文本的值
	 *
	 */
	changeText = (val: string) => {
	    let {onFilterChange, dataIndex} = this.props;
	    this.setState({
	        value: val
	    }, () => {
	        onFilterChange && onFilterChange(dataIndex, val, this.state.condition);
	    });
	}

	/**
	 * 输入框回车执行回调
	 *
	 */
	changeTextCall = (e: React.KeyboardEvent<HTMLInputElement>) => {
	    let {onFilterChange, dataIndex} = this.props;
	    if (e.keyCode == 13) {
	        (e.target as HTMLInputElement).value !== "" && onFilterChange && onFilterChange(dataIndex, (e.target as HTMLInputElement).value, this.state.condition);
	    }
	}
	/**
	 * 更改修改值
	 *
	 */
	// changeValue = () => {
	//     this.setState({
	//         value: ""
	//     });
	// }
	/**
	 * 下拉条件的回调
	 *
	 * @param {*} key 字段
	 * @param {*} value 值1,2,3...6
	 */
	onSelectDropdown = (item: Record<string, any>) => {
	    let {onFilterChange, dataIndex} = this.props;
	    this.setState({
	        condition: item.key
	    }, () => {
	        this.state.value !== "" && onFilterChange && onFilterChange(dataIndex, this.state.value, this.state.condition);
	    });
	}

	/**
	 * 修改数值型的值
	 *
	 */
	changeNumber = (value: string) => {
	    let {onFilterChange, dataIndex} = this.props;
	    this.setState({
	        value
	    }, () => {
	        onFilterChange && onFilterChange(dataIndex, value, this.state.condition);
	    });
	}
	// // 清除数值
	// clearNumber = () => {
	//     let {onChange} = this.props;
	//     onChange && onChange("");
	//     this.setState({
	//         value: ""
	//     });
	// }

	// // 失去焦点后执行函数
	// changeTextCallBlur = (val: string) => {
	//     let {onChange} = this.props;
	//     onChange && onChange(val);
	// }
	// 设置下拉值
	changeSelect = (value: string) => {
	    let {onFilterChange, dataIndex} = this.props;
	    if (onFilterChange) {
	        onFilterChange(dataIndex, value, this.state.condition);
	        this.setState({
	            value
	        });
	    }
	}
	// 清除下拉值
	// clearSelectValue = () => {
	//     this.setState({
	//         selectValue: ""
	//     }, () => {
	//         this.changeSelect("");
	//     });
	// }
	// 清除日期值
	// clearDateValue = () => {
	//     this.setState({
	//         dateValue: ""
	//     }, () => {
	//         this.changeDate("");
	//     });
	// }
	// 设置日期值
	changeDate = (value: any) => {
	    let {onFilterChange, dataIndex} = this.props;
	    if (onFilterChange) {
	        onFilterChange(dataIndex, value, this.state.condition);
	        this.setState({
	            value,
	            open: false
	        });
	    }
	}
	// 设置时间值
	// @ts-ignore 函数参数校验
	changeTime = (time: any, timeString: string) => {
	    let {onFilterChange, dataIndex} = this.props;
	    if (onFilterChange) {
	        onFilterChange(dataIndex, timeString, this.state.condition);
	        this.setState({
	            value: timeString,
	            timeOpen: false
	        });
	    }
	}
	// 组件渲染
	/**
	 * 根据不同的类型生成对应的组件类型包含一些参数的适应
	 *
	 * @param {*} rendertype 参数类型，包括['text','dropdown','date','dateyear','datemonth','dateweek',daterange','number']
	 * @returns
	 */
	renderControl = (rendertype: string) => {
	    let {
	        filterDropdownOptions,
	        filterInputNumberOptions,
	        filterDropdownIncludeKeys,
	        dataIndex,
	        filterDropdown,
	        filterDropdownType,
	        format,
	        className,
	        onChange,
	        onSelectDropdown,
	        clsPrefix,
	        locale
	    } = this.props;
	    switch (rendertype) {
	    case 'text':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <Input
	                value={this.state.value}
	                className={className}
	                onChange={this.changeText}
	                onKeyDown={this.changeTextCall}
	                {...filterDropdownOptions as Partial<InputProps>}
	                // onBlur={this.changeTextCallBlur}
	            />
	            <FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowClear={this.state.value}
	                isShowCondition={filterDropdown}
	                filterDropdownType={filterDropdownType}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'number':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <InputNumber
	                className={className}
	                value={this.state.value}
	                onChange={this.changeNumber}
	                iconStyle="one"
	                {...filterDropdownOptions as Partial<InputNumberDefaultProps>}
	                {...(filterInputNumberOptions as Partial<InputNumberDefaultProps>)}
	            />
	            <FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowClear={Number(this.state.value) != 0}
	                isShowCondition={filterDropdown}
	                filterDropdownType={filterDropdownType}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'dropdown':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <Select
	                    {...this.props}
	                    locale={this.props.locale as string}
	                    dataIndex={this.props.dataIndex as number}
	                    size="small"
	                value={this.state.value}
	                onChange={this.changeSelect}
	                    {...filterDropdownOptions as Partial<SelectProps>}
	            /><FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowCondition={filterDropdown}
	                isShowClear={this.state.value}
	                filterDropdownType={filterDropdownType}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	            </div>
	    case 'date':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <DatePicker
	                {...this.props}
	                value={this.state.value}
	                onChange={this.changeDate}
	                open={this.state.open}
	                format={format}
	                locale={locale as string}
	                {...filterDropdownOptions as Partial<DatePickerProps>}
	            /><FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowCondition={filterDropdown}
	                isShowClear={this.state.value}
	                filterDropdownType={filterDropdownType}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'dateyear':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <YearPicker
	                {...this.props}
	                value={this.state.value}
	                onChange={this.changeDate}
	                open={this.state.open}
	                format={format}
	                locale={locale as string}
	                {...filterDropdownOptions as Partial<DatePickerProps>}
	            /><FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowCondition={filterDropdown}
	                isShowClear={this.state.value}
	                filterDropdownType={filterDropdownType}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'datemonth':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <MonthPicker
	                {...this.props}
	                value={this.state.value}
	                onChange={this.changeDate}
	                open={this.state.open}
	                format={format}
	                locale={locale as string}
	                {...filterDropdownOptions as Partial<DatePickerProps>}
	            /><FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowCondition={filterDropdown}
	                isShowClear={this.state.value}
	                filterDropdownType={filterDropdownType}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'dateweek':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <WeekPicker
	                {...this.props}
	                value={this.state.value}
	                onChange={this.changeDate}
	                open={this.state.open}
	                format={format}
	                locale={locale as string}
	                {...filterDropdownOptions as Partial<DatePickerProps>}
	            /><FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowCondition={filterDropdown}
	                isShowClear={this.state.value}
	                filterDropdownType={filterDropdownType}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'daterange':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <RangePicker
	                {...this.props}
	                value={this.state.value}
	                onChange={this.changeDate}
	                open={this.state.open}
	                format={format}
	                showTime
	                locale={locale as string}
	                placeholder={'开始 ~ 结束'}
	                dateInputPlaceholder={['开始', '结束']}
	                allowClear
	                {...filterDropdownOptions as Partial<RangePickerProps>}
	            /><FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowCondition={filterDropdown}
	                isShowClear={this.state.value}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'time':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <TimePicker
	                {...omit(this.props, ['clsPrefix'])}
	                value={this.state.value}
	                onChange={this.changeTime}
	                // open={this.state.timeOpen}
	                // onOpen={() => this.setState({timeOpen: true})}
	                format={format}
	                locale={locale as string}
	                {...filterDropdownOptions as Partial<TimePickerProps>}
	            /><FilterDropDown
	                locale={locale}
	                dataIndex={dataIndex}
	                dataText={this.state.value}
	                onSelectDropdown={this.onSelectDropdown}
	                onClickClear={this.clearFilter}
	                isShowCondition={filterDropdown}
	                isShowClear={this.state.value}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    case 'bool':
	        return <div className={`${clsPrefix} filter-wrap`}>
	            <Switch
	                className={className}
	                onChange={onChange}
	                {...filterDropdownOptions as Partial<SwitchProps>}
	            />
	            <FilterDropDown locale={locale}
	                onSelectDropdown={onSelectDropdown}
	                filterDropdownIncludeKeys={filterDropdownIncludeKeys}
	            />
	        </div>
	    default:
	        return <div></div>;
	    }

	}

	render() {
	    let {rendertype} = this.props;
	    return (
	        <div data-filter-type='filterContext'>{this.renderControl(rendertype)}</div>
	    );
	}
}

// FilterType.propTypes = propTypes;
// FilterType.defaultProps = {
//     filterDropdown: 'show'
// }
export default FilterType;
